/* eslint-disable */
<template>
  <div class="vh-100 d-flex justify-content-center">
    <div class="form-access my-auto">
      <div id="logo_holder" class="mt-2 mb-5">
        <img id="efocs_logo" src="@/assets/images/EFOCS_Logo_Horizontal.svg" alt="EFOCS" />
      </div>
      <div class="btn-group d-flex mtb15 login-account-type-toggle" role="group">
        <input type="radio" class="btn-check w-100" id="loginreal" autocomplete="off" value="live" v-model="accountType">
        <label class="btn btn-outline-primary" for="loginreal">{{ t("liveLabel") }}</label>
        <input type="radio" class="btn-check w-100" id="logindemo" value="demo" v-model="accountType" autocomplete="off">
        <label class="btn btn-outline-primary" for="logindemo">{{ t("demoLabel") }}</label>
      </div>
      <form autocomplete="off">
        <div class="form-group">
          <input v-model="name" type="email" name="login-username" autocomplete="off" class="form-control" :placeholder="t('usernamePlaceholder')" required />
        </div>
        <div class="form-group">
          <input v-model="password" type="password" name="login-password" autocomplete="new-password" class="form-control" :placeholder="t('passwordLabel')" required />
        </div>
        <div class="login-options">
          <div v-if="'demo' === accountType" class="custom-control form-check">
            <input type="checkbox" class="form-check-input" id="form-checkbox" v-model="shouldRememberDemo" />
            <label class="form-check-label" for="form-checkbox">
              {{ t("rememberMeLabel") }}
            </label>
          </div>
          <div v-else class="custom-control form-check">
            <input type="checkbox" class="form-check-input" id="form-checkbox" v-model="shouldRememberLive" />
            <label class="form-check-label" for="form-checkbox">
              {{ t("rememberMeLabel") }}
            </label>
          </div>
          <router-link v-if="'demo' === accountType" to="/recover">{{ t("forgotPasswordLabel") }}</router-link>
        </div>
        <button type="submit" class="btn btn-primary"
          :disabled='!submitEnabled && !blockLogin' @click.prevent="doLogin()">{{ t("loginLabel") }}</button>
      </form>
      <h2 v-if="'demo' === accountType">
        <router-link to="/create-account">{{ t("createDemoLabel") }}</router-link>
      </h2>
      <h2 v-else>
        <a href="https://my.eurofinance.bg/" target="_blanc">{{ t("createAccountLabel") }}</a>
      </h2>
    </div>
  </div>
</template>
<script>
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import http from "@/api/http-common";
import I18n from "@/lang/i18n.js";
import HttpUtils from "@/assets/js/http_utils.js";
import ApiUtils from "@/assets/js/api_utils.js";
import { buildWebAppVersionSignalRUrl } from "@/config/endpoints";

function getAccountTypeFromUrl(url) {
  if (!url) {
    return null;
  }

  const accountType = new URL(url, window.location.origin).searchParams.get("accountType");
  return ["live", "demo"].includes(accountType) ? accountType : null;
}

function getRequestedAccountType() {
  const currentUrlAccountType = getAccountTypeFromUrl(window.location.href);
  if (currentUrlAccountType) {
    return currentUrlAccountType;
  }

  return getAccountTypeFromUrl(document.referrer);
}

/**
 * this method identifies unique stocks in list with O(n) complexity (fastest possible)
 * taken from https://stackoverflow.com/questions/15125920/how-to-get-distinct-values-from-an-array-of-objects-in-javascript
 */
/*
 function onlyUnique(array) {
  const unique = [];
  const distinct = [];
  for (let i = 0; i < array.length; i++) {
    if (!unique[array[i].cMIC + array[i].code]) {
      distinct.push(array[i]);
      unique[array[i].cMIC + array[i].code] = 1;
    }
  }

  return distinct;
} */

export default {
  name: 'LoginVue',
  data() {
    return {
      shouldRememberDemo: this.$store.getters["getRememberMeDemo"],
      shouldRememberLive: this.$store.getters["getRememberMeLive"],
      name: '',
      password: '',
      accountType: getRequestedAccountType() || this.$store.getters["getLastOpenedUserType"],
      blockLogin: false,
      currentLanguage: this.$store.getters["getNonLoggedInLanguage"] || "EN",
      mess: this.message,
      mType: parseInt(this.messageType),
      versionConnection: null,
      versionConnectionRetryTimer: null,
      versionListenerStopped: false,
      webAppVersion: 1790928251
    }
  },
  props: {
    message: {
      required: false,
      type: String
    },
    messageType: {
      required: false,
      type: String
    }
  },  
  watch: {
    getUserLanguage: function (newVal) {
      this.currentLanguage = newVal;
    },
    accountType: function (newVal) {
      this.setStoredUsername(newVal);
      if (["live", "demo"].includes(newVal) && this.$route.query.accountType !== newVal) {
        this.$router.replace({
          name: "Login",
          query: { ...this.$route.query, accountType: newVal }
        });
      }
    },
    "$route.query.accountType": function (newVal) {
      if (["live", "demo"].includes(newVal) && newVal !== this.accountType) {
        this.accountType = newVal;
      }
    }
  },  
  methods: {
        t(key, ...args) {
            const language = this.currentLanguage || (typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage);
            return I18n.t(key, language, ...args);
        },
    setStoredUsername(newVal) {
      if (0 === "demo".localeCompare(newVal)) {
        this.name = this.$store.getters["getRememberMeDemo"]
          ? this.$store.getters["getRememberedUsernameDemo"]
          : '';
        this.password = this.$store.getters["getRememberMeDemo"]
          ? this.$store.getters["getRememberedPasswordDemo"]
          : '';
      } else {
        this.name = this.$store.getters["getRememberMeLive"]
          ? this.$store.getters["getRememberedUsernameLive"]
          : '';
        this.password = this.$store.getters["getRememberMeLive"]
          ? this.$store.getters["getRememberedPasswordLive"]
          : '';
      }
    },
    async doLogin() {
      // block login button
      this.blockLogin = true;
      const isDemo = "demo".localeCompare(this.accountType) === 0;
      // store if needed
      if (isDemo) {
        this.$store.commit("setRememberMeDemo", this.shouldRememberDemo);
        if (this.shouldRememberDemo) {
          this.$store.commit("setRememberedUsernameDemo", this.name);
          this.$store.commit("setRememberedPasswordDemo", this.password);
        }
      } else {
        this.$store.commit("setRememberMeLive", this.shouldRememberLive);
        if (this.shouldRememberLive) {
          this.$store.commit("setRememberedUsernameLive", this.name);
          this.$store.commit("setRememberedPasswordLive", this.password);
        }
      }
      const payload = {
        api: http,
        username: this.name,
        password: this.password,
        demo: isDemo
      };
      try {
        this.$store.commit("setAppStateNotReady");
        const loginResult = await this.$store.dispatch("loginUser", payload);
        // get the error message if appropriate
        const errorCode = HttpUtils.getStatusMessage(loginResult, this.currentLanguage);
        if (errorCode === "") {
            // set last login type
            this.$store.commit("setLastOpenedUserType", this.accountType);
            // do not load anything until all data is collected in dashboard vue
            this.$router.push({ name: "Dashboard" });
        } else {
            this.blockLogin = false;

            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
            this.$store.commit("setAppStateReady");
        }
      } catch(error) {
        this.blockLogin = false;
        console.error(error);
        this.$store.commit("setAppStateReady");
      }
    },
    getUserType() {
      return this.$store.getters["getUserType"];
    },  
    isNewerWebAppVersion(version) {
      const receivedVersion = Number(version);
      const currentVersion = Number(this.webAppVersion);
      return Number.isFinite(receivedVersion) && Number.isFinite(currentVersion) && receivedVersion > currentVersion;
    },
    handleWebAppVersionMessage(message) {
      if (message && this.isNewerWebAppVersion(message.version)) {
        window.location.reload();
      }
    },
    scheduleVersionConnectionRetry() {
      if (this.versionListenerStopped || this.versionConnectionRetryTimer) {
        return;
      }

      this.versionConnectionRetryTimer = window.setTimeout(() => {
        this.versionConnectionRetryTimer = null;
        this.startVersionConnection();
      }, 30000);
    },
    async startVersionConnection() {
      if (this.versionListenerStopped || !this.versionConnection) {
        return;
      }

      try {
        await this.versionConnection.start();
      } catch (error) {
        this.scheduleVersionConnectionRetry();
      }
    },
    startWebAppVersionListener() {
      const connection = new HubConnectionBuilder()
        .withUrl(buildWebAppVersionSignalRUrl())
        .withAutomaticReconnect([0, 2000, 10000, 30000])
        .configureLogging(LogLevel.None)
        .build();

      connection.on("CurrentVersion", this.handleWebAppVersionMessage);
      connection.on("VersionChanged", this.handleWebAppVersionMessage);
      connection.onclose(() => this.scheduleVersionConnectionRetry());
      this.versionConnection = connection;
      this.startVersionConnection();
    },
  },
  computed: {
    submitEnabled() {
      return this.name.length > 0 && this.password.length > 0;
    },
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"] || "EN";
    }
  },
  async mounted() {
    this.setStoredUsername(this.accountType);
    // reset store to avoid users access to other user's data
    this.$store.commit("resetStoreState", null);
    // redirect
    this.$store.commit("setUser", null);
    this.$store.commit("setNonLoggedInLanguage", "EN");
    // default lang if not set
    this.currentLanguage = this.getUserLanguage;
    // show message if any
    setTimeout(() => {
      const pendingNotification = ApiUtils.consumePendingLoginNotification();
      const message = pendingNotification?.message || this.message;
      const messageType = pendingNotification
        ? parseInt(pendingNotification.messageType)
        : parseInt(this.messageType);
      if (message) {
        if (0 === messageType) {
          this.$toast.success(message, {
            "duration": 5000,
            "pauseOnHover": true
          });
        } else {
          this.$toast.error(message, {
            "duration": 5000,
            "pauseOnHover": true
          });
        }
      }      
    }, 500);
    this.startWebAppVersionListener();
  },
  unmounted() {
    this.versionListenerStopped = true;
    if (this.versionConnectionRetryTimer) {
      clearTimeout(this.versionConnectionRetryTimer);
    }
    if (this.versionConnection) {
      this.versionConnection.stop();
    }
  }
}
</script>
<style scoped>
  #efocs_logo {
    width: 11rem;
    max-width: 100%;
    height: auto;
  }

  #logo_holder {
    text-align: center;
  }

  .login-account-type-toggle > .btn {
    flex: 1 1 0;
  }

  .login-account-type-toggle .btn-outline-primary {
    border-color: #0088aa;
    color: #0088aa;
  }

  .login-account-type-toggle .btn-outline-primary:hover,
  .login-account-type-toggle .btn-outline-primary:focus,
  .login-account-type-toggle .btn-check:checked + .btn-outline-primary {
    background-color: #0088aa;
    border-color: #0088aa;
    color: #ffffff;
  }

  .form-access .btn-primary {
    background-color: #0088aa;
    border-color: #0088aa;
  }

  .form-access .btn-primary:hover,
  .form-access .btn-primary:focus,
  .form-access .btn-primary:active {
    background-color: #006f8c;
    border-color: #006f8c;
  }

  .form-access a {
    color: #0088aa;
  }

  .form-access a:hover,
  .form-access a:focus {
    color: #006f8c;
  }

  .login-options .form-check-input {
    accent-color: #0088aa;
  }

  .login-options {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 1.5rem;
  }

  .login-options .form-check {
    align-items: center;
    display: flex;
    margin-bottom: 0;
    padding-left: 0;
  }

  .login-options .form-check-input {
    float: none;
    margin: 0 0.4rem 0 0;
    position: static;
  }
</style>
